"use client";

import dynamic from "next/dynamic";

import type { SliderGenericProps } from "./SliderAutoPlay";

const SliderAutoPlay = dynamic(() => import("./SliderAutoPlay").then(mod => mod.SliderAutoPlay));

export default function SliderAutoPlayWrapper(props: SliderGenericProps) {
  return <SliderAutoPlay {...props} />;
}
